<button tabindex="-1" class="close-button" [mat-dialog-close]="undefined" mat-icon-button><mat-icon class="notranslate">close</mat-icon></button>

<h1>{{ model.title }}</h1>

<mat-dialog-content>
  <div class="lo_sensitive html-content" [innerHTML]="model.content | safeHtml"></div>
</mat-dialog-content>
